import { useTranslate } from '@tolgee/react';
import { options } from './constants';
import { setmessageSettingsAttributes } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { useDispatch, useSelector } from 'react-redux';

export const StartSettings: React.FC<any> = (props) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    aiAssistant: {
      conversation: { messageSettings }
    }
  } = useSelector((state: any) => state.lomavisCreator);

  return (
    <div className="card p-4 h-100">
      <h4 className="w-100 text-center">
        {t('lomavisCreator.aiAssistant.startSettings')}
      </h4>
      <div className="d-flex flex-column justify-content-end h-100">
        <div className="mb-5 row">
          {options.map(({ name: optionKey, options }) => (
            <div key={optionKey} className="mb-3">
              <label htmlFor={optionKey} className="form-label mb-1">
                {t(`lomavisCreator.aiAssistant.labels.${optionKey}`)}
              </label>
              <select
                defaultValue={messageSettings?.[optionKey]}
                id={optionKey}
                className="form-select"
                onChange={(e) =>
                  dispatch(
                    setmessageSettingsAttributes({
                      [optionKey]:
                        e.target.value === '0' ? null : e.target.value
                    })
                  )
                }
              >
                {options.map(({ key, label }) => (
                  <option key={key} value={key} onClick={() => {}}>
                    {t(label)}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
